/* unplugin-vue-components disabled */import { render } from "./sliderinput.vue?vue&type=template&id=870e6436&scoped=true"
import script from "./sliderinput.vue?vue&type=script&lang=js"
export * from "./sliderinput.vue?vue&type=script&lang=js"

import "./sliderinput.vue?vue&type=style&index=0&id=870e6436&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-870e6436"]])

export default __exports__